"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancellableWait = void 0;
function wait(delay) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}
exports.default = wait;
const cancellableWait = (delay) => {
    let timeout;
    const wait = () => {
        return new Promise((resolve) => {
            timeout = setTimeout(resolve, delay);
        });
    };
    const cancel = () => {
        timeout && clearTimeout(timeout);
    };
    return {
        wait,
        cancel,
    };
};
exports.cancellableWait = cancellableWait;
